import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Box, TextField, Button, Paper,
} from '@material-ui/core';
import styles from './PopPassword.module.css';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { INFO, ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import { INPUT, ROLE_CODE } from '../../../common/const';
import {
  setSystemLodingFLg,
  setErrPopMsg,
  setConfirmPopFlg,
  setPasswordPopFlg,
  setPopMessage,
  setOnClickYesFunction,
  setOnClickNoFunction,
  setInfoMessage,
  getUserInfo,
  setErrorMessage,
  updatePassword,
} from '../../actions/CommonAction';

class PopPasswordComponent extends Component {
  constructor() {
    super();
    this.state = {
      oldPassword: null,
      newPassword: null,
      newPasswordConfirm: null,
      errOldPassword: null,
      errNewPassword: null,
      errNewPasswordConfirm: null,
      errOldPasswordFlg: false,
      errNewPasswordFlg: false,
      errNewPasswordConfirmFlg: false,
    };
  }

  /**
   * stateの初期化
   */
  initState = () => {
    const {
      setErrPopMsgAct,
      setConfirmPopFlgAct,
    } = this.props;
    setErrPopMsgAct(null);
    setConfirmPopFlgAct(false);

    this.setState({ oldPassword: null });
    this.setState({ newPassword: null });
    this.setState({ newPasswordConfirm: null });
    this.setState({ errOldPassword: null });
    this.setState({ errNewPassword: null });
    this.setState({ errNewPasswordConfirm: null });
    this.setState({ errOldPasswordFlg: false });
    this.setState({ errNewPasswordFlg: false });
    this.setState({ errNewPasswordConfirmFlg: false });
  }

  /**
   * 元のパスワードバリデーションチェック
   */
  onBlurOldPassword = () => {
    const {
      oldPassword,
    } = this.state;

    // 元のパスワードの入力チェック
    const msgs = [];
    this.checkOldPassword(
      oldPassword, msgs,
    );
  }

  /**
   * 新規パスワードバリデーションチェック
   */
  onBlurNewPassword = () => {
    const {
      newPassword,
    } = this.state;

    // 新規パスワードの入力チェック
    const msgs = [];
    this.checkNewPassword(
      newPassword, msgs,
    );
  }

  /**
  * 新規パスワード(確認用)バリデーションチェック
  */
  onBlurNewPasswordConfirm = () => {
    const {
      newPasswordConfirm,
    } = this.state;

    // 新規パスワード(確認用)の入力チェック
    const msgs = [];
    this.checkNewPasswordConfirm(
      newPasswordConfirm, msgs,
    );
  }

  /**
 * 元のパスワードチェック関数
 * 文字種チェック & 30文字チェック
 * @param {*} oldPassword パスワード文字列
 * @param {*} msgs メッセージ
 * @returns 判定結果(true：入力誤り、false：正しい入力)
 */
  checkOldPassword = (oldPassword, msgs) => {
    // 元のパスワードの入力チェック
    validator.checkMaxLength(oldPassword, 30, msgs);
    validator.checkChar(oldPassword, VALIDATOR_CONST.PATERN_PASSWORD, msgs);
    // 入力チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errOldPassword: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errOldPasswordFlg: true });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errOldPassword: '' });
    this.setState({ errOldPasswordFlg: false });
    return false;
  }

  /**
   * 新規パスワードチェック関数
   * 文字種チェック & 8文字以上30文字以下チェック
   * @param {*} newPassword パスワード文字列
   * @param {*} msgs メッセージ
   * @returns 判定結果(true：入力誤り、false：正しい入力)
   */
  checkNewPassword = (newPassword, msgs) => {
    // 新規パスワードの入力チェック
    validator.checkLengthRange(newPassword, 8, 30, msgs);
    validator.checkChar(newPassword, VALIDATOR_CONST.PATERN_PASSWORD, msgs);
    // 文字数チェック&文字種チェック入力チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errNewPassword: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errNewPasswordFlg: true });
      return true;
    }
    validator.checkChar(newPassword, VALIDATOR_CONST.PATERN_ALPHABET_NUM_LEAST_ONE, msgs);
    // パスワード最低文字チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errNewPassword: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errNewPasswordFlg: true });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errNewPassword: '' });
    this.setState({ errNewPasswordFlg: false });
    return false;
  }

  /**
 * 新規パスワード(確認用)チェック関数
 * 文字種チェック & 8文字以上30文字以下チェック
 * @param {*} newPasswordConfirm パスワード文字列
 * @param {*} msgs メッセージ
 * @returns 判定結果(true：入力誤り、false：正しい入力)
 */
  checkNewPasswordConfirm = (newPasswordConfirm, msgs) => {
    // 新規パスワードの入力チェック
    validator.checkLengthRange(newPasswordConfirm, 8, 30, msgs);
    validator.checkChar(newPasswordConfirm, VALIDATOR_CONST.PATERN_PASSWORD, msgs);
    // 文字数チェック&文字種チェック入力チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errNewPasswordConfirm: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errNewPasswordConfirmFlg: true });
      return true;
    }
    validator.checkChar(newPasswordConfirm, VALIDATOR_CONST.PATERN_ALPHABET_NUM_LEAST_ONE, msgs);
    // パスワード最低文字チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errNewPasswordConfirm: getMessage(ERROR.E08009, msgs.join(',')) });
      this.setState({ errNewPasswordConfirmFlg: true });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errNewPasswordConfirm: '' });
    this.setState({ errNewPasswordConfirmFlg: false });
    return false;
  }

  /**
   * 変更ボタン押下時の処理
   */
  onClickUpdateButton = () => {
    const {
      oldPassword,
      newPassword,
      newPasswordConfirm,
    } = this.state;
    const {
      setErrPopMsgAct,
      setConfirmPopFlgAct,
      setPopMessageAct,
      setOnClickYesFunctionAct,
      setOnClickNoFunctionAct,
    } = this.props;
    const msgs = [];
    // 必須チェック
    validator.checkRequired(INPUT.USERMANAGED.OLD_PASSWORD, oldPassword, msgs);
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errOldPasswordFlg: true });
      return;
    }
    validator.checkRequired(INPUT.USERMANAGED.NEW_PASSWORD, newPassword, msgs);
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errNewPasswordFlg: true });
      return;
    }
    validator.checkRequired(INPUT.USERMANAGED.NEW_PASSWORD_CONFIRM, newPasswordConfirm, msgs);
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errNewPasswordConfirmFlg: true });
      return;
    }
    // 文字種チェック
    if (this.checkOldPassword(
      oldPassword, msgs,
    )) {
      return;
    }
    if (this.checkNewPassword(
      newPassword, msgs,
    )) {
      return;
    }
    if (this.checkNewPasswordConfirm(
      newPasswordConfirm, msgs,
    )) {
      return;
    }
    // 元のパスワードと新規パスワードの相違チェック
    validator.checkSame(
      INPUT.USERMANAGED.OLD_PASSWORD, INPUT.USERMANAGED.NEW_PASSWORD,
      oldPassword, newPassword, msgs,
    );
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errOldPasswordFlg: true });
      this.setState({ errNewPasswordFlg: true });
      this.setState({ errNewPasswordConfirmFlg: true });
      return;
    }
    // 新規パスワードと新規パスワード(確認用)の同値チェック
    validator.checkDifference(
      INPUT.USERMANAGED.NEW_PASSWORD, INPUT.USERMANAGED.NEW_PASSWORD_CONFIRM,
      newPassword, newPasswordConfirm, msgs,
    );
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errNewPasswordFlg: true });
      this.setState({ errNewPasswordConfirmFlg: true });
      return;
    }
    // 確認POPUPの表示
    setPopMessageAct(INFO.I04001);
    setOnClickYesFunctionAct(this.onClickYesButton);
    setOnClickNoFunctionAct();
    setConfirmPopFlgAct(true);
  }

  /**
  * 確認POPUP「はい」選択時の処理
  */
  onClickYesButton = async () => {
    const {
      oldPassword,
      newPassword,
    } = this.state;
    const {
      inflowType,
      setSystemLodingFlgAct,
      setPasswordPopFlgAct,
      setInfoMessageAct,
      getUserInfoAct,
      updatePasswordAct,
    } = this.props;
    // パスワード変更API呼出し
    setSystemLodingFlgAct(true);
    if (await updatePasswordAct(oldPassword, newPassword) === false) {
      setSystemLodingFlgAct(false);
      return;
    }
    setSystemLodingFlgAct(false);

    // 処理分岐
    if (inflowType === '1') {
      const { history } = this.props;
      // state初期化
      this.initState();
      setPasswordPopFlgAct(false);
      // ユーザー情報取得
      const userInfo = await getUserInfoAct();
      if (userInfo && userInfo.role_list) {
        // ユーザ認証が正常に完了した場合、各画面へ遷移
        if (userInfo.role_list.indexOf(ROLE_CODE.COMPANY) >= 0) history.push('/searchcompany');
        else if (userInfo.role_list.indexOf(ROLE_CODE.TARGET) >= 0) history.push('/targetcompany');
        else if (userInfo.role_list.indexOf(ROLE_CODE.MATCHING) >= 0) history.push('/matchingcompany');
        else if (userInfo.role_list.indexOf(ROLE_CODE.UPLOAD) >= 0 && userInfo.transaction_contact === 1) history.push('/uploadcompanyinfo');
        else if (userInfo.role_list.indexOf(ROLE_CODE.USERMANAGED) >= 0) history.push('/usermanaged');
        else if (userInfo.role_list.indexOf(ROLE_CODE.LOGOUTPUT) >= 0) history.push('/logoutput');
        else if (userInfo.role_list.indexOf(ROLE_CODE.EXTERNALDATA) >= 0 && (userInfo.businesscard_contact === 1 || userInfo.common_contract === 1)) history.push('/externaldata');
        else history.push('/error');
        setInfoMessageAct(INFO.I04002);
      } else { history.push('/error'); }
    } else {
      // state初期化
      this.initState();
      setInfoMessageAct(INFO.I04002);
      setPasswordPopFlgAct(false);
    }
  }

  /**
   * キャンセルボタン押下時の処理
   */
  onClickCancelButton = () => {
    const {
      setPasswordPopFlgAct,
    } = this.props;
    // state初期化
    this.initState();
    setPasswordPopFlgAct(false);
  }

  render() {
    const {
      oldPassword,
      newPassword,
      newPasswordConfirm,
      errOldPassword,
      errNewPassword,
      errNewPasswordConfirm,
      errOldPasswordFlg,
      errNewPasswordFlg,
      errNewPasswordConfirmFlg,
    } = this.state;
    const {
      passwordPopFlg,
      errPopMsg,
    } = this.props;
    return (
      passwordPopFlg && (
        <Paper>
          <div className={`${styles.poppassword}`}>
            <div className={`${styles.contents}`}>
              <div className={`${styles.message1}`}>パスワードを変更してください。</div>
              <div className={`${styles.message2}`}>※パスワードをお忘れの際は、各部門の管理者へ問い合わせをお願いします。</div>
              <div className={`${styles.message3}`}>{errPopMsg}</div>
              <ul className={`${styles.passwordContent}`}>
                <li className={`${styles.row}`}>
                  <div className={`${styles.title}`}>元のパスワード</div>
                  <div className={`${styles.item}`}>
                    <TextField
                      type="password"
                      variant="outlined"
                      className={`${styles.input}`}
                      InputProps={{ classes: { input: styles.inputSizing } }}
                      value={oldPassword || ''}
                      onChange={(ev) => this.setState({ oldPassword: ev.target.value })}
                      onBlur={this.onBlurOldPassword}
                      error={errOldPasswordFlg}
                    />
                  </div>
                </li>
                <li className={`${styles.errorRow}`}>
                  <div>
                    <span className={`${styles.error}`}>{errOldPassword}</span>
                  </div>
                </li>
                <li className={`${styles.row}`}>
                  <div className={`${styles.title}`}>新規パスワード</div>
                  <div className={`${styles.item}`}>
                    <TextField
                      type="password"
                      variant="outlined"
                      className={`${styles.input}`}
                      InputProps={{ classes: { input: styles.inputSizing } }}
                      value={newPassword || ''}
                      onChange={(ev) => this.setState({ newPassword: ev.target.value })}
                      onBlur={this.onBlurNewPassword}
                      error={errNewPasswordFlg}
                    />
                  </div>
                </li>
                <li className={`${styles.errorRow}`}>
                  <div>
                    <span className={`${styles.error}`}>{errNewPassword}</span>
                  </div>
                </li>
                <li className={`${styles.row}`}>
                  <div className={`${styles.title}`}>新規パスワード(確認用)</div>
                  <div className={`${styles.item}`}>
                    <TextField
                      type="password"
                      variant="outlined"
                      className={`${styles.input}`}
                      InputProps={{ classes: { input: styles.inputSizing } }}
                      value={newPasswordConfirm || ''}
                      onChange={(ev) => this.setState({ newPasswordConfirm: ev.target.value })}
                      onBlur={this.onBlurNewPasswordConfirm}
                      error={errNewPasswordConfirmFlg}
                    />
                  </div>
                </li>
                <li className={`${styles.errorRowbottom}`}>
                  <div>
                    <span className={`${styles.error}`}>{errNewPasswordConfirm}</span>
                  </div>
                </li>
              </ul>
              <div className={`${styles.button}`}>
                <Box>
                  <Button
                    variant="contained"
                    className={`${styles.cancelcolor} cancel`}
                    onClick={this.onClickCancelButton}
                  >
                    キャンセル
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={`${styles.normalcolor}`}
                    onClick={this.onClickUpdateButton}
                  >
                    変更
                  </Button>
                </Box>
              </div>
            </div>
          </div>
        </Paper>
      )
    );
  }
}

export default connect(
  (state) => ({
    inflowType: state.common.inflowType,
    errPopMsg: state.common.errPopMsg,
    passwordPopFlg: state.common.passwordPopFlg,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrPopMsgAct: (str) => dispatch(setErrPopMsg(str)),
    setConfirmPopFlgAct: (bool) => dispatch(setConfirmPopFlg(bool)),
    setPasswordPopFlgAct: (bool) => dispatch(setPasswordPopFlg(bool)),
    setPopMessageAct: (str) => dispatch(setPopMessage(str)),
    setOnClickYesFunctionAct: (func) => dispatch(setOnClickYesFunction(func)),
    setOnClickNoFunctionAct: (func) => dispatch(setOnClickNoFunction(func)),
    setInfoMessageAct: (str) => dispatch(setInfoMessage(str)),
    getUserInfoAct: () => dispatch(getUserInfo()),
    setErrorMessageAct: (messages) => dispatch(setErrorMessage(messages)),
    updatePasswordAct: (
      oldPassword, newPassword,
    ) => dispatch(updatePassword(
      oldPassword, newPassword,
    )),
  }),
)(withRouter(PopPasswordComponent));
